
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBrwul6cW5XPjys9lVX6HHqdZVS85GfaTw",
  authDomain: "portfolio-c3a5d.firebaseapp.com",
  projectId:"portfolio-c3a5d",
  storageBucket: "portfolio-c3a5d.appspot.com",
  messagingSenderId: "76859585721",
  appId: "1:76859585721:web:91284b79b04f543f999768",
  measurementId: "G-C8KE9P5R49"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
